<div class="custom-input">
  {{ label }}
  <input id="phone" #phone class="form-control {{inputClassList}}" type="text" (input)="onChange($event)" [ngModel]="inputValue"/>
</div>
